// extracted by mini-css-extract-plugin
export default {"nav-link-custom":"NavBarLink_nav-link-custom__2z3+O","resume-btn":"NavBarLink_resume-btn__cwjYd"};